(() => {
  const params = new URLSearchParams(location.search);
  const start = new Date(params.get('event_start_time') || '');
  const end = new Date(params.get('event_end_time') || '');
  const valid = Number.isFinite(start.getTime()) && Number.isFinite(end.getTime()) && end > start && end - start <= 24 * 60 * 60 * 1000;
  document.querySelectorAll('[data-open-days-thanks]').forEach((page) => {
    if (!valid) return;
    page.querySelector('[data-appointment]').hidden = false;
    page.querySelector('[data-appointment-date]').textContent = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(start);
    page.querySelector('[data-appointment-time]').textContent = `${new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: 'numeric', minute: '2-digit' }).format(start)}–${new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: 'numeric', minute: '2-digit' }).format(end)}`;
    const stamp = (date) => date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    const calendar = page.querySelector('[data-calendar]');
    const content = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Smile White//Open Days//EN', 'BEGIN:VEVENT', `UID:${start.getTime()}-open-day@smilewhite.co.uk`, `DTSTAMP:${stamp(new Date())}`, `DTSTART:${stamp(start)}`, `DTEND:${stamp(end)}`, 'SUMMARY:Smile White Open Day', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n') + '\r\n';
    calendar.href = URL.createObjectURL(new Blob([content], {type:'text/calendar;charset=utf-8'}));
    calendar.download = 'smile-white-open-day.ics';
    calendar.hidden = false;
    try {
      const url = new URL(params.get('reschedule_url'));
      if (url.protocol === 'https:' && url.hostname === 'booking.smilewhite.co.uk' && !url.username && !url.password && /^\/booking\/(?:[^/]+\/)?reschedule$/.test(url.pathname)) {
        const link = page.querySelector('[data-reschedule]');
        link.href = url.href;
        link.hidden = false;
      }
    } catch { /* Missing or invalid links remain hidden. */ }
  });
})();
